export default "__VITE_ASSET__b1203b35__"